import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import course05 from "../../../course/course-05/course";
import lesson0218 from "../../course-02/lesson-18/lesson";
import lesson0219 from "../../course-02/lesson-19/lesson";
import lesson0221 from "../../course-02/lesson-21/lesson";
import lesson0503 from "../lesson-03/lesson";
import lesson0504 from "../lesson-04/lesson";
import lesson0506 from "../lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "ba05ee7f-6993-4f89-ac9b-9e9cef45764d",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
  {
    id: "bf872c0b-6d81-4d48-b360-7301bb16f4bb",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0504),
    lesson: lesson0504,
  },
  {
    id: "9debe0b7-2c36-4ff5-a0b9-566c7e8743a8",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
  {
    id: "02c48af2-aafc-43b6-8942-1f6f97826cd3",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0218),
    lesson: lesson0218,
  },
  {
    id: "df11e105-99c2-46da-9353-5280d1f337f4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0219),
    lesson: lesson0219,
  },
  {
    id: "aa02ef2a-c019-4764-aec5-9d0fa155a868",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0221),
    lesson: lesson0221,
  },
];

export default lessonLinks;
